import { Box } from '@zillow/constellation-10';
import { Bone } from '@zg-rentals/satellite-components';
import InboxPanelHeaderSkeleton from './components/Header/skeleton';

const Skeleton = (): JSX.Element => {
  return (
    <Box css={{ paddingInline: 'default' }}>
      <InboxPanelHeaderSkeleton />

      <Bone type="line" css={{ width: '33.33%', marginBottom: 'default' }} />
      <Bone type="line" css={{ marginBottom: 'default' }} />
      <Bone type="line" css={{ width: '58.33%', marginBottom: 'default' }} />
      <Bone type="line" css={{ marginBottom: 'default' }} />

      <Bone type="line" css={{ width: '33.33%', marginBottom: 'default' }} />
      <Bone type="line" css={{ marginBottom: 'default' }} />
      <Bone type="line" css={{ width: '58.33%', marginBottom: 'default' }} />
      <Bone type="line" css={{ marginBottom: 'default' }} />
    </Box>
  );
};

export default Skeleton;
